<template>
  <div class="mt-5">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-12 col-lg-10">
          <div class="card">
            <div class="d-flex">
              <h3 class="font-weight-light ml-3 mr-auto">Pagamento de Conta</h3>
              <WhiteLabel class="ml-auto mt-1 pull-right mr-4">
                <router-link :to="{ name: 'bills-payment' }">
                  <i class="icon-arrow-left-circle"></i> Voltar
                </router-link>
              </WhiteLabel>
            </div>
            <hr />
            <div class="card-content">
              <div class="form-row col-12">
                <div class="col-12 col-w-full">
                  <WhiteLabel>
                    <h4 class="font-weight-light blue">
                      Informações do Beneficiário
                    </h4>
                  </WhiteLabel>
                </div>
                <div
                  class="form-group col-12 col-w-full col-lg-6 col-xl-6 mb-4"
                >
                  <label>Nome</label>
                  <p>{{ paymentDetail.recipientName }}</p>
                </div>
                <div
                  class="form-group col-12 col-w-full col-lg-6 col-xl-6 mb-4"
                >
                  <label>CPF/CNPJ</label>
                  <p>{{ paymentDetail.recipientDocument }}</p>
                </div>
              </div>
              <div class="form-row col-12">
                <div class="col-12 col-w-full">
                  <WhiteLabel>
                    <h4 class="font-weight-light blue">
                      Informações do Pagamento
                    </h4>
                  </WhiteLabel>
                </div>
                <div
                  class="form-group col-12 col-w-full col-lg-12 col-xl-12 mb-4"
                >
                  <label>Linha digitável</label>
                  <p>{{ paymentDetail.barCode }}</p>
                </div>
                <div
                  class="form-group col-12 col-w-full col-lg-6 col-xl-6 mb-4"
                >
                  <label>Descrição</label>
                  <p>{{ paymentDetail.description }}</p>
                </div>
                <div
                  class="form-group col-12 col-w-full col-lg-6 col-xl-6 mb-4"
                >
                  <label>Protocolo</label>
                  <p>{{ paymentDetail.protocolId }}</p>
                </div>
                <div
                  class="form-group col-12 col-w-full col-lg-6 col-xl-6 mb-4"
                >
                  <label>Valor</label>
                  <p>
                    {{
                      paymentDetail.value
                        | currency('R$ ', 2, {
                          decimalSeparator: ',',
                          thousandsSeparator: '.',
                        })
                    }}
                  </p>
                </div>
                <div
                  class="form-group col-12 col-w-full col-lg-6 col-xl-6 mb-4"
                >
                  <label>Valor pago</label>
                  <p>
                    {{
                      paymentDetail.valuePaid
                        | currency('R$ ', 2, {
                          decimalSeparator: ',',
                          thousandsSeparator: '.',
                        })
                    }}
                  </p>
                </div>
                <div
                  class="form-group col-12 col-w-full col-lg-6 col-xl-6 mb-4"
                >
                  <label>Juros</label>
                  <p>
                    {{
                      paymentDetail.penalty
                        | currency('R$ ', 2, {
                          decimalSeparator: ',',
                          thousandsSeparator: '.',
                        })
                    }}
                  </p>
                </div>
                <div
                  class="form-group col-12 col-w-full col-lg-6 col-xl-6 mb-4"
                >
                  <label>Desconto</label>
                  <p>
                    {{
                      paymentDetail.discount
                        | currency('R$ ', 2, {
                          decimalSeparator: ',',
                          thousandsSeparator: '.',
                        })
                    }}
                  </p>
                </div>
                <div
                  class="form-group col-12 col-w-full col-lg-6 col-xl-6 mb-4"
                >
                  <label>Data e hora da transação</label>
                  <p>
                    {{ paymentDetail.createdAt | moment('DD/MM/YYYY HH:mm:ss') }}
                  </p>
                </div>
                <div class="row">
                  <div
                    class="col-12 col-w-full col-md-12 col-lg-12 col-xl-12 mb-4"
                  >
                    <h6 class="font-weight-light text-muted mb-1">Status</h6>
                    <div class="d-flex">
                      <div class="mr-2">
                        <span
                          class="badge badge-pill"
                          :class="statusColor(paymentDetail.status)"
                        >
                          <p class="text-uppercase m-0">
                            {{ getStatusPayment(paymentDetail.status) }}
                          </p>
                        </span>
                      </div>
                      <p v-if="paymentDetail.status === 'paid'">
                        {{
                          paymentDetail.paymentDate
                            | moment('DD/MM/YYYY HH:mm:ss')
                        }}
                      </p>
                      <p v-if="paymentDetail.status === 'canceled'">
                        {{
                          paymentDetail.canceledDate
                            | moment('DD/MM/YYYY HH:mm:ss')
                        }}
                      </p>
                      <p v-if="paymentDetail.status === 'reproved'">
                        {{
                          paymentDetail.rejectedDate
                            | moment('DD/MM/YYYY HH:mm:ss')
                        }}
                      </p>
                      <p v-if="paymentDetail.status === 'chargeback'">
                        {{
                          paymentDetail.chargebackAt
                            | moment('DD/MM/YYYY HH:mm:ss')
                        }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import paymentDetailsCommonMethods from './paymentDetailsCommonMethods.js';

export default {
  name: 'AppPaymentDetailsTypeRendimento',
  mixins: [paymentDetailsCommonMethods],
  props: {
    paymentDetail: {
      type: Object,
      required: true,
      validator(value) {
        return (
          value &&
          typeof value.barCode === 'string' &&
          'valuePaid' in value &&
          'preset' in value
        );
      },
    },
  },
};
</script>
